var metadata                  = require('./_metadata')
  , anObject                  = require('./_an-object')
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
}});


//////////////////
// WEBPACK FOOTER
// C:/Users/gbelizaire/Documents/ang2tut/resulatbac/~/core-js/modules/es7.reflect.define-metadata.js
// module id = ../../../../core-js/modules/es7.reflect.define-metadata.js
// module chunks = 0